export type PromotionBalanceEntryStatus =
    'QUEUED' |
    'IN_USE' |
    'COMPLETED' |
    'EXPIRED' |
    'OPT_OUT' |
    'DISABLED';